export default __webpack_public_path__ + "static/media/ted-garcia-marked.f6a8ea01.png";